import { useMemo } from 'react'
import MessageCard from '@groovehq/internal-design-system/lib/components/MessageCard/MessageCard'
import {
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { isBridgeChannelType } from 'ducks/channels/channelTypes'
import { rem } from '@groovehq/internal-design-system/lib/util'
import { css } from '@emotion/react'
import { CHANNEL_TYPES } from '../Channels.data'

const btnIcon = theme => css`
  svg {
    width: ${rem(24)};
    height: ${rem(24)};
    background: ${theme.color.monochrome.white};
    border-radius: 50%;
    vertical-align: middle;
  }
`

export default function useSourceWording(source) {
  return useMemo(
    () => {
      if (source === 'inbox') {
        return {
          drawerTitle: 'Reconnect Gmail',
          title: `Re-authenticate your Gmail ${app.t('mailbox')}.`,
          intro: (
            <>
              <p>
                Occasionally Gmail may require re-authentication if Google has
                changed their permissions or if your Gmail account has updated
                your security settings or changed your password.
              </p>

              <MessageCard type="warning" className="grui mt-11">
                <div css={text.styles.fontMedium}>Heads up</div>
                <p css={paragraph.styles.preflight} className="grui my-5">
                  Groove will reprocess the last 100 emails received and import
                  any missing conversations.
                </p>
              </MessageCard>
            </>
          ),
        }
      }
      if (isBridgeChannelType(source)) {
        const { name, icon } = CHANNEL_TYPES[source] || {}
        return {
          drawerTitle: `Reconnect ${name}`,
          title: `Re-authenticate ${name}`,
          intro: (
            <>
              <p>
                Reconnect {name} to give Groove access to your page again. In
                addition to{' '}
                <span css={[text.styles.fontSemibold]}>
                  selecting any new pages
                </span>{' '}
                that you want to use, make sure to{' '}
                <span css={[text.styles.fontSemibold]}>
                  keep all currently connected pages
                </span>.
              </p>
            </>
          ),
          btnText: (
            <>
              <span css={btnIcon} className="grui mr-4">
                {icon}
              </span>
              Re-authenticate {name}
            </>
          ),
        }
      }
      return {}
    },
    [source]
  )
}
